import React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { TableHeadComponent } from "../../../common/TableHead";
import { useSiteAboutStore } from "./siteAboutStore/siteAboutStore";

export const EvalinkTab = () => {
  const { evalinkData } = useSiteAboutStore();

  const titlesArray = [
    "Evalink Company ID",
    "Evalink Token",
    "Evalink Device ID",
  ];

  return (
    <TableContainer component={Paper} sx={{ width: "screen" }}>
      {evalinkData && (
        <Table
          sx={{
            postion: "absolute",
            width: "screen",
            fontFamily: "Mulish",
          }}
        >
          <TableHeadComponent titlesArray={titlesArray} />
          <TableBody>
            <TableRow>
              <TableCell align="left" sx={{ fontFamily: "Mulish" }}>
                {evalinkData.evalink_company_id}
              </TableCell>
              <TableCell align="left" sx={{ fontFamily: "Mulish" }}>
                {evalinkData.evalink_token}
              </TableCell>
              <TableCell align="left" sx={{ fontFamily: "Mulish" }}>
                {evalinkData.evalink_device_id}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      )}
      {!evalinkData && (
        <p className="font-mulish text-[#283E6D] text-[20px] text-center">
          No Evalink info added.
        </p>
      )}
    </TableContainer>
  );
};
